<script setup lang="ts">
import type { HighlightColors } from "../colors/colors";
import type { CommandItemBaseProps } from "./types";
import { computed } from "vue";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps & {
  color: [string, typeof HighlightColors[keyof typeof HighlightColors] | ""];
}>();

const name = computed(() => props.color[0]);
const hexColor = computed(() => props.color[1]);

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .setHighlight({ color: hexColor.value })
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    @click="run"
    @keydown.enter="run"
  >
    <template #icon>
      <span
        class="flex size-4 flex-row items-center justify-center rounded-sm border border-slate-200"
        :style="{ backgroundColor: hexColor }"
        aria-hidden="true"
      >
        A
      </span>
    </template>
    <span>
      <span class="capitalize">{{ name }}</span> background
    </span>
  </SuggestionListItem>
</template>
